/**
 * FIN-FORMA-OBRIGATORIA Ato 1 (I.168): forma de pagamento pré-marcada na importação de NF-e de compra,
 * lida da tag de pagamento da nota (pag/detPag/tPag). Caminho único: usado pelo Importar XML e pela
 * nota da SEFAZ (notas de entrada).
 *
 * Regra do Diretor (A4): traduz só quando há forma igual no cadastro da empresa; tag ausente, "Outros"
 * ou sem forma igual → '' (o campo fica vazio e obrigatório). Nota com tags de formas diferentes → ''.
 */
const TPAG_TO_CODE: Record<string, string> = {
  '01': 'money', // Dinheiro
  '02': 'check', // Cheque
  '03': 'credit_card', // Cartão de Crédito
  '04': 'debit_card', // Cartão de Débito
  '15': 'bank_transfer', // Boleto Bancário (código do cadastro)
  '17': 'pix', // Pix dinâmico
  '20': 'pix', // Pix estático
};

/**
 * @param tags valores de tPag da nota, na ordem do XML
 * @param activeCodes códigos das formas ATIVAS da empresa
 * @returns o código da forma, ou '' quando a nota não define uma forma única do cadastro
 */
export function paymentCodeFromNfeTags(
  tags: ReadonlyArray<string | null | undefined>,
  activeCodes: ReadonlyArray<string | null | undefined>,
): string {
  const codes = new Set<string>();
  for (const tag of tags) {
    const code = TPAG_TO_CODE[(tag ?? '').trim()];
    if (!code) return '';
    codes.add(code);
  }
  if (codes.size !== 1) return '';
  const [code] = Array.from(codes);
  return activeCodes.includes(code) ? code : '';
}
